import { PlusIcon } from "lucide-react";

import { Button } from "shared/ui/shadcn/button";

import { Divider } from "@/modules/email-templates-sidebar/shared/divider";
import { useEmailTemplateSSDrafts } from "@/hooks/use-email-templates-manager";
import { EMAIL_TEMPLATE_LOCAL_DRAFTS_KEY_TYPES } from "@/hooks/use-email-templates-manager";
import { useCallingContext } from "@/hooks/dialer/use-dialer-context";
import { useEmailTemplatesSidebarContext } from "@/components/modules/email-templates-sidebar/context";
import { CUSTOM_EVENTS } from "@/constants/custom-events";
import { dispatchCustomEvent } from "@/helpers/events";
import { OpenFollowupEmailDraftEventDataI } from "@/interfaces/events/email";
import { FollowupSectionSettings } from "@/modules/pipeline/account-details/sections/email-section/followup-section/settings";
import { useEffect, useMemo, useState } from "react";
import { EmailDraftI } from "@/components/modules/email-templates-sidebar/interfaces";

export const FollowupSection = () => {
  const { call } = useCallingContext();
  const { onOpen: openEmailTemplatesSidebar } =
    useEmailTemplatesSidebarContext();
  const { getLocalDraft, setLocalDraft } = useEmailTemplateSSDrafts(
    EMAIL_TEMPLATE_LOCAL_DRAFTS_KEY_TYPES.CALL_ID
  );

  const [draft, setDraft] = useState<EmailDraftI | undefined>(undefined);

  const callId = useMemo(() => {
    return call?.customParameters.get("call_id") as string;
  }, [call]);

  useEffect(() => {
    const draft = getLocalDraft(callId);

    setDraft(draft);
  }, [callId]);

  const handleOnClick = () => {
    const draft = getLocalDraft(callId);

    openEmailTemplatesSidebar();

    setTimeout(() => {
      dispatchCustomEvent({
        eventType: CUSTOM_EVENTS.ACCOUNT.EMAIL_TEMPLATES.OPEN_FOLLOWUP_DRAFT,
        data: {
          draft,
        } as OpenFollowupEmailDraftEventDataI,
      });
    }, 100);
  };

  const handleOnChange = ({
    isEnabled,
    maxFollowups,
    intervalDays,
  }: {
    isEnabled: boolean;
    maxFollowups: number;
    intervalDays: number;
  }) => {
    const draft = getLocalDraft(callId);

    if (draft) {
      setDraft({
        ...draft,
        max_follow_ups: isEnabled ? maxFollowups : undefined,
        follow_up_interval_days: isEnabled ? intervalDays : undefined,
      });
    }
  };

  useEffect(() => {
    if (draft) {
      setLocalDraft(callId, draft);
    }
  }, [draft]);

  return (
    <section>
      <Divider className="my-4" />

      <div className="flex w-full flex-col gap-3">
        <div className="flex w-full items-center justify-between">
          <div>
            <h6 className="typography-body-4-medium">Follow-ups</h6>
          </div>

          <div>
            <Button
              variant="link"
              className="text-[#0F35FF]"
              type="button"
              onClick={handleOnClick}
            >
              <PlusIcon className="size-4" />
              Preview email | Configure follow-ups
            </Button>
          </div>
        </div>

        <FollowupSectionSettings
          isEnabled={
            !!draft?.max_follow_ups && !!draft?.follow_up_interval_days
          }
          intervalDays={draft?.follow_up_interval_days}
          maxFollowups={draft?.max_follow_ups}
          onChange={handleOnChange}
        />
      </div>
      <Divider className="my-4" />
    </section>
  );
};
